module.exports = __webpack_public_path__ + "media/images/flags/1x1/umi-a9a36cdad3d8919f2be3ee76f4085efa.svg";